import {
    Input,
    Component,
    OnInit,
    Output,
    EventEmitter,
    OnDestroy
  } from '@angular/core';
import { SocketService } from '../../../../providers';
import { Subscription } from 'rxjs/Subscription';

@Component({
  selector: 'temperature-mode-actuator',
  templateUrl: 'temperature-mode-actuator.html'
})
export class TemperatureModeActuatorComponent implements OnInit, OnDestroy {
  @Output() endpointChange: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateName: EventEmitter<any> = new EventEmitter();
  @Output() endpointUpdateNotification: EventEmitter<any> = new EventEmitter();
  
  @Input() device: any;
  @Input() endpoint: any;
  @Input() updatedName: any;
  @Input() updatedNotification: any;

  public data: any;
  public notifications: boolean = false;
  private ioMeasure$: Subscription;

  constructor(private socketService: SocketService) {}

  ngOnInit() {
    this.data = { ...this.endpoint };
    this.notifications = this.data.mobile_notification;

    this.initSocketIO();
  }

  initSocketIO() {
    this.ioMeasure$ = this.socketService.onMeasureCreated().subscribe((measure: any) => {
      this.updateMeasure(measure);
    });
  }

  updateMeasure(measure: any) {
    if (measure.device !== this.device._id || measure.endpoint !== this.data._id) {
      return;
    }

    this.data.current = measure.value;
  }

  updateNotification() {
    this.endpointUpdateNotification.emit({
      device: this.device._id,
      endpoint: this.data._id,
      currentNotifications: this.notifications
    });
  }

  updateName() {
    this.endpointUpdateName.emit({
      device: this.device._id,
      endpoint: this.data._id,
      currentName: this.data.display_name
    });
  }

  onChangeEndpoint(value) {
    this.data.current = value;

    this.endpointChange.emit({
      updated: true,
      _id: this.data._id,
      value: this.data.current
    });
  }

  ngOnDestroy() {
    if (this.ioMeasure$) {
      this.ioMeasure$.unsubscribe();
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/node-actuator/actuators/temperature-mode-actuator/temperature-mode-actuator.ts